import { objectToQueryString } from "../../../helpers/objectToQueryString";
import { API } from "../../api";
async function get_parcel_with_code(query) {
    const url = process.env.LETS_TRADE_ORDER_URL ?? "";
    return await new API().apiGet({
        baseUrl: url,
        endpoint: `v2/parcel${objectToQueryString(query)}`,
    });
}
export { get_parcel_with_code };
